interface Props {
  width?: string;
  height?: string;
  className?: string;
}

export function Skeleton({ width = '100%', height = '1rem', className = '' }: Props) {
  return (
    <div
      className={`animate-pulse rounded bg-canvas-inset ${className}`}
      style={{ width, height }}
    />
  );
}
